<div class="pl-page">

  <!-- The hero band: the site's card wash with a glow of the theme's colours, the title and one line, and a
       chip per product that jumps to its box. -->
  <header class="pl-hero">
    <div class="pl-hero-inner">
      <h1 class="tools-title">Apps &amp; Plugins</h1>
      <p class="tools-subtitle">Codigrate apps, plugins and extensions to boost your productivity</p>
      <nav class="pl-chips" aria-label="Apps and plugins">
        <a *ngFor="let box of boxes" class="pl-chip" [attr.href]="'/plugins#' + box.id" (click)="jumpTo( box.id, $event )">
          <img [src]="box.icon" alt="" width="18" height="18">
          <span>{{ box.name }}</span>
        </a>
      </nav>
    </div>
  </header>

  <!-- every product as the home's box (owner 2026-10-12: the page laid out as the home) -->
  <div class="pl-boxes">
    <app-product-showcase *ngFor="let box of boxes" class="pl-box" [id]="box.id" tabindex="-1"
                          [config]="box.config"></app-product-showcase>
  </div>

</div>
